import { Search } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";

export const FORMAT_OPTIONS = [["all", "All formats"], ["novel", "Books"], ["comic", "Comics"], ["manga", "Manga"], ["webtoon", "Webtoons"], ["poetry", "Poetry"]];

export const FormatFilter = ({ q, setQ, fmt, setFmt }) => (
  <div className="flex flex-col sm:flex-row gap-3 mb-10" data-testid="showcase-filters">
    <div className="relative flex-1 max-w-md">
      <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search titles, authors, series…" data-testid="showcase-search-input"
        className="w-full bg-slate-900/80 border border-amber-500/25 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-amber-400" />
    </div>
    <Select value={fmt} onValueChange={setFmt}>
      <SelectTrigger className="sm:w-48 bg-slate-900/80 border-amber-500/25" data-testid="showcase-format-select"><SelectValue /></SelectTrigger>
      <SelectContent>{FORMAT_OPTIONS.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`showcase-format-option-${v}`}>{l}</SelectItem>)}</SelectContent>
    </Select>
  </div>
);
